import { BaseModel } from "sjs-base-model";
import SubscriptionDateRangesModel from "./SubscriptionDateRangesModel";

// Returned Api Data sample
// const example = {
//     id: 1,
//     name: "TBD",
//     description: "testDummy"
// };

export default class SubscriptionModel extends BaseModel {
    id = 0;
    folderId = 0;
    name = "";
    description = "";
    comment = "";
    typeId = 0;
    hasSubscriptions = false;
    dateRanges = SubscriptionDateRangesModel;
    isFilterable = false;
    specialType = null;

    constructor(data) {
        super();
        this.update(data);
    }
}
